import { authApiService } from '@/api/authApiService';
import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';

export const reinviteRecipientProxyApi = (wireId: string): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/organization/wires/${wireId}/recipient-proxy/reinvite/`;

  return authApiService.POST(uri, {});
};
